import Footer from "./components/Footer";
import ViewProject from "./page/Avax/Launchpad/ViewProject";
import { AppContainer } from "./styled";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import "./App.css";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ContextProviderWrapper } from "./components/Context";
import { Toaster } from "react-hot-toast";
import { useContext, useEffect } from "react";
import LayoutDashboard from "./Layout/Dashboard";
import Swap from "./page/Avax/Swap";
import Farm from "./page/Avax/Farm";
import Launchpad from "./page/Avax/Launchpad";
import Liquidity from "./page/Avax/Liquidity";
import Community from "./page/Avax/Community";
import { store } from "./store/store";
import { Provider } from "react-redux";
import IDODetail from "./page/Avax/Launchpad/Detail";
import AddLiquidity from "./page/Avax/Liquidity/Add";
import CreatePoolLiquidity from "./page/Avax/Liquidity/CreatePool";
import LiquidityDetails from "./page/Avax/Liquidity/Details";
import LayoutLiquidity from "./Layout/Liquidity";
import GlobalStyle from "./GlobalStyle";
import Kibble from "./page/Avax/Kibble";
import DetailV2 from "./page/Avax/Liquidity/DetailV2";
import Leaderboard from "./page/Avax/Leaderboard";
import LaunchForm from "./page/Avax/Launchpad/Form";
import ProviderConnectWallet from "./components/Provider";

// TON
import FarmTon from "./page/Ton/Farm";
import LaunchpadTon from "./page/Ton/Launchpad";
import LiquidityTon from "./page/Ton/Liquidity";
import CommunityTon from "./page/Ton/Community";
import IDODetailTon from "./page/Ton/Launchpad/Detail";
import AddLiquidityTon from "./page/Ton/Liquidity/Add";
import CreatePoolLiquidityTon from "./page/Ton/Liquidity/CreatePool";
import LiquidityDetailsTon from "./page/Ton/Liquidity/Details";
import Campaign from "./page/Leaderboard/Campaign";
import PrivateRoute from "./routers/PrivateRoute";
import Profile from "./page/Profile";

global.Buffer = Buffer;
window.global ||= window;
global.process = process;

const App = () => {
  const { pathname } = useLocation();
  const { theme, isMobile } = useContext(ContextProviderWrapper)!;

  useEffect(() => {
    if (pathname) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return (
    <Provider store={store}>
      <ProviderConnectWallet>
        <TonConnectUIProvider manifestUrl="https://dev-kibble-avax.netlify.app/static/tonconnect-manifest.json">
          <Toaster
            position="top-right"
            reverseOrder={false}
            toastOptions={{
              style: {
                fontFamily: "Syne",
              },
            }}
          />
          <GlobalStyle theme={theme} />
          <AppContainer
            className={`${theme} ${
              pathname === "/kibble" && theme === "dark"
                ? "is-kibble"
                : pathname === "/kibble" && theme === "light"
                ? `is-kibble ${theme}`
                : ""
            }`}
            pathname={pathname === "/"}
          >
            <div
              style={{
                mixBlendMode: theme === "light" ? "color-burn" : "color-dodge",
              }}
              className="img-k-top-right"
            >
              {theme === "light" ? (
                <img src="/assets/images/common/img-k-light.png" alt="" />
              ) : (
                <img src="/assets/images/common/img-k.png" alt="" />
              )}
            </div>
            <div
              style={{
                mixBlendMode: theme === "light" ? "color-burn" : "color-dodge",
              }}
              className="img-k-bottom-left"
            >
              {theme === "light" ? (
                <img src="/assets/images/common/img-k-light.png" alt="" />
              ) : (
                <img src="/assets/images/common/img-k.png" alt="" />
              )}
            </div>
            <Routes>
              {/* Avax path */}
              <Route element={<LayoutDashboard chain="Avalanche" />}>
                <Route
                  index
                  path="/swap/avax"
                  element={<Swap chainRouter="Avalanche" />}
                />
                <Route path="/staking/avax" element={<Farm />} />
                <Route path="/launchpad/avax" element={<Launchpad />} />
                <Route path="/kibble/avax" element={<Kibble />} />
                <Route path="/launchpad/avax/:id" element={<IDODetail />} />
                <Route
                  path="/launchpad/avax/:id/view"
                  element={<ViewProject />}
                />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="/campaign" element={<Campaign />} />
                <Route
                  path="/profile"
                  element={
                    <PrivateRoute>
                      <Profile />
                    </PrivateRoute>
                  }
                />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="launchpad/form" element={<LaunchForm />} />
                <Route path="/liquidity/avax" element={<LayoutLiquidity />}>
                  <Route index element={<Liquidity />} />
                  <Route path="v2/:id" element={<DetailV2 />} />
                  <Route path="provide/v1" element={<AddLiquidity />} />
                  <Route path="provide" element={<AddLiquidity />} />
                  <Route path="details/:id" element={<LiquidityDetails />} />
                  <Route path="init/avax" element={<CreatePoolLiquidity />} />
                </Route>
                <Route path="community-tool/avax" element={<Community />} />
                <Route path="/*" element={<Navigate to="/swap/avax" />} />
              </Route>

              {/* Solana path */}
              <Route element={<LayoutDashboard chain="Solana" />}>
                <Route
                  index
                  path="/swap/solana"
                  element={<Swap chainRouter="Solana" />}
                />
                <Route path="/*" element={<Navigate to="/swap/solana" />} />
              </Route>

              {/* Ton path */}
              <Route element={<LayoutDashboard chain="Toncoin" />}>
                <Route
                  index
                  path="/swap/ton"
                  element={<Swap chainRouter="Toncoin" />}
                />
                <Route path="/staking/ton" element={<FarmTon />} />
                <Route path="/launchpad/ton" element={<LaunchpadTon />} />
                <Route path="/launchpad/ton/:id" element={<IDODetailTon />} />
                <Route path="/liquidity/ton" element={<LayoutLiquidity />}>
                  <Route index element={<LiquidityTon />} />
                  <Route
                    path="/liquidity/ton/provide"
                    element={<AddLiquidityTon />}
                  />
                  <Route
                    path="/liquidity/ton/details/:id"
                    element={<LiquidityDetailsTon />}
                  />
                  <Route
                    path="/liquidity/ton/init"
                    element={<CreatePoolLiquidityTon />}
                  />
                </Route>
                <Route path="/community-tool/ton" element={<CommunityTon />} />
                <Route path="/*" element={<Navigate to="/swap/ton" />} />
              </Route>
            </Routes>
            {!isMobile && <Footer />}
          </AppContainer>
        </TonConnectUIProvider>
      </ProviderConnectWallet>
    </Provider>
  );
};

export default App;
